export function normalizePath(path) {
  return path.replace(/\/+$/, '') || '/'
}
